import React from 'react';
import PropTypes from 'prop-types';
import {t} from 'common/utils/translation-util';
import StoryboardChapterIcon from 'storyboard/components/storyboard-chapter-icon';
import * as ModalType from 'storyboard/constants/modal-type';
import Colors from 'common/constants/colors';
import './index.scss';

export default class StoryboardAddChapterButton extends React.Component {
  static propTypes = {
    enums: PropTypes.object.isRequired,
    fontSize: PropTypes.string,
    height: PropTypes.number,
    label: PropTypes.string,
    openModal: PropTypes.func,
    textColor: PropTypes.string,
    width: PropTypes.number,
  };

  static defaultProps = {
    fontSize: '1.5vmin',
    height: 0,
    label: t('Add a chapter'),
    openModal: () => {},
    textColor: Colors.white,
    width: 0,
  };

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    const {ChapterIconEnum} = this.props.enums;
    return (
      <div className={'StoryboardAddChapterButton'}>
        <a href={'#'} onClick={this.handleClick}>
          <StoryboardChapterIcon
            active={true}
            type={ChapterIconEnum.ADD_CHAPTER.id}
          />
          <div
            className={'StoryboardChapterLabel'}
            style={{
              color: this.props.textColor,
              fontSize: this.props.fontSize,
            }}>
            {this.props.label}
          </div>
        </a>
      </div>
    );
  }

  handleClick(event) {
    event.preventDefault();
    this.props.openModal(ModalType.ADD_CHAPTER, this.props.label);
  }
}
